import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { NewAndExistingUsers } from '../../../../models/program/new-and-existing-users';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { ExistingUser } from '../../../../models/program/existing-user';
import { SearchService } from './../../../../shared/services/search.service';
import { EditionListService } from './../../../../editions/edition.service';
import { JourneyUser } from '../../../../models/journey/journey-user';

@Component({
  selector: 'app-add-journey-users',
  templateUrl: './add-journey-users.component.html',
  styleUrls: ['./add-journey-users.component.less']
})

export class AddJourneyUsersComponent {
  @Output() submit: EventEmitter<ExistingUser[]> = new EventEmitter();
  @Output() bulkSubmit: EventEmitter<any> = new EventEmitter();
  @Input() journeyUsers: JourneyUser[];
  @Input() errors: string[];
  @Input() saving: boolean;

  public usersToAdd: ExistingUser[];
  public csv: File;
  public ssoFieldName: string;

  constructor(
    private editionList: EditionListService,
    private searchService: SearchService,
  ) {}

  ngOnInit(): void {
    this.editionList.getEditionDetailsObservable().subscribe(
      edition => {
        console.log('edition: ', edition)
      }
    );
    this.editionList.getEditionDetailsObservable().map(edition => edition['sso_field_name']).subscribe(
      ssoFieldName => {
        this.ssoFieldName = ssoFieldName;
      }
    );
  }

  public onAdding = (tag): Observable<any> => {
    return of(tag);
  }

  public searchForExisting = (query: string): Observable<ExistingUser[]> => {
    // Uses arrow notation to maintain scope
    let current_user_ids = this.journeyUsers.map(u => u.id);
    return this.searchService.queryExistingUsers(query)
      .map(returnedUsers => {
        returnedUsers = returnedUsers.filter(user => current_user_ids.indexOf(user.id) < 0);
        return returnedUsers as ExistingUser[];
      })
  }

  public usersChange(updatedUsers: ExistingUser[]): void {
    this.usersToAdd = updatedUsers;
  }

  public blankMatchingFn() {
    return true;
  }

  public submitNewUsers(): void {
    this.submit.emit(this.usersToAdd);
  }

  public postFile(file: File): void {
    this.csv = file;
  }

  public addByCsv(file: any): void {
    this.bulkSubmit.emit(file);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/journeys/journey/add-journey-users/add-journey-users.component.ts